import Avatar from '../Avatar'

import { getUserStatusColor } from './AvatarWithStatus.utils'

import * as styles from './AvatarWithStatus.module.css'

function AvatarWithStatus({ Icon, color, size, src, status, text }) {
  const statusColor = getUserStatusColor(status)

  return (
    <Avatar Icon={Icon} color={color} size={size} src={src} text={text}>
      {statusColor ? (
        <div
          className={styles.statusIndicator}
          style={{ backgroundColor: statusColor }}
        />
      ) : null}
    </Avatar>
  )
}

export default AvatarWithStatus
